import type { TFunction } from '@mint-lib/i18n';

import { BUILDER_ROW_TYPES } from '../constants/campaignBuilder.js';
import type { RowToRemoveObject } from '../pages/Builder/types.js';
import { Platform } from '../types/integrations.js';

export const getRemoveModalText = (
  rowToRemove: RowToRemoveObject | null,
  t: TFunction,
) => {
  if (!rowToRemove) {
    return '';
  }

  const { type, hasChildren, campaign } = rowToRemove;

  if (type !== BUILDER_ROW_TYPES.TILE) {
    return hasChildren
      ? t('All child rows will be removed accordingly. Proceed?')
      : t('The row will be deleted. Proceed?');
  }

  if (campaign) {
    return t(
      'Are you sure you want to delete this row? The row will be deleted in ALL Buying Plans of this campaign',
    );
  }

  return t(
    'The row will be deleted. It will not effect any changes on tile settings.',
  );
};

export function filterByOmniConnectorFlag(
  integration: Platform,
  flags: Record<string, boolean>,
): boolean {
  const omniConnectorFlagValue = flags[integration.platform];
  return omniConnectorFlagValue !== undefined
    ? omniConnectorFlagValue === integration.isOmni
    : true;
}
